import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

const DepartmentIcon = (props) => {
  const { className, ...rest } = props;
  const classes = clsx('custom-icon', className);

  return (
    <svg width="20" height="20" data-type="fill" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={classes} {...rest}>
      <path className="ci-path" fill="none" d="M16.6666 13.3353V12.2242C16.6666 11.6348 16.3154 11.0696 15.6903 10.6528C15.0652 10.2361 14.2173 10.002 13.3333 10.002H6.66663C5.78257 10.002 4.93472 10.2361 4.3096 10.6528C3.68448 11.0696 3.33329 11.6348 3.33329 12.2242V13.3353" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
      <line className="ci-path" x1="9.99996" y1="13.3346" x2="9.99996" y2="6.66797" strokeWidth="1.66667" strokeLinecap="round" />
      <rect x="1.66663" y="15.002" width="3.33333" height="3.33333" rx="0.833333" />
      <rect x="8.33329" y="15.002" width="3.33333" height="3.33333" rx="0.833333" />
      <rect x="15" y="15.002" width="3.33333" height="3.33333" rx="0.833333" />
      <rect x="7.49996" y="1.66797" width="5" height="3.33333" rx="0.833333" />
    </svg>
  );
};

DepartmentIcon.defaultProps = {
  className: '',
};

DepartmentIcon.propTypes = {
  className: PropTypes.string,
};

export default DepartmentIcon;
